import {
  type CreateCurrencyRequest,
  type CurrencyDetail,
  CurrencyDetailSchema,
  type CurrencyListQuery,
  type CurrencyListResponse,
  CurrencyListResponseSchema,
  type UpdateCurrencyRequest,
} from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';

/**
 * Currency master API. Every response is validated with the shared Zod schema.
 */

export const listCurrencies = async (query: CurrencyListQuery): Promise<CurrencyListResponse> => {
  const { data } = await apiClient.get<unknown>('/currencies', { params: query });
  return CurrencyListResponseSchema.parse(data);
};

export const getCurrency = async (id: string): Promise<CurrencyDetail> => {
  const { data } = await apiClient.get<unknown>(`/currencies/${id}`);
  return CurrencyDetailSchema.parse(data);
};

export const createCurrency = async (payload: CreateCurrencyRequest): Promise<CurrencyDetail> => {
  const { data } = await apiClient.post<unknown>('/currencies', payload);
  return CurrencyDetailSchema.parse(data);
};

export const updateCurrency = async (
  id: string,
  payload: UpdateCurrencyRequest,
): Promise<CurrencyDetail> => {
  const { data } = await apiClient.patch<unknown>(`/currencies/${id}`, payload);
  return CurrencyDetailSchema.parse(data);
};

export const deleteCurrency = async (id: string): Promise<void> => {
  await apiClient.delete(`/currencies/${id}`);
};

export const bulkDeleteCurrencies = async (
  ids: string[],
): Promise<{ updated: number; failed: { id: string; error: string }[] }> => {
  const { data } = await apiClient.post<{
    updated: number;
    failed: { id: string; error: string }[];
  }>('/currencies/bulk-delete', { ids });
  return data;
};

export const bulkSetCurrenciesStatus = async (
  ids: string[],
  isActive: boolean,
): Promise<{ updated: number; failed: { id: string; error: string }[] }> => {
  const { data } = await apiClient.post<{
    updated: number;
    failed: { id: string; error: string }[];
  }>('/currencies/bulk-set-status', { ids, isActive });
  return data;
};
